import React, { ReactNode } from 'react'

//CSS styling for "BoxInfo" can be found in the _variables.scss file
//CSS key-words include: 'info', 'success-msg-checkmark-animation', 'success', 'fail' & 'post'
interface IBoxInfo {
	css: string
	message: string | object | ReactNode
	image?: string
	button?: object
}

export const BoxInfo = ({ css, message }: IBoxInfo) => (
	<div className={`box-info ${css}`}>{message}</div>
)

export const BoxInfoWithButton = ({ css, message, button }: IBoxInfo) => (
	<div className="box-info box-info-button">
		<div className={`message-container ${css}`}>{message}</div>
		<div className="button-container">{button}</div>
	</div>
)

export const BoxInfoCardApplication = ({ css, message, image }: IBoxInfo) => (
	<div className={`box-info ${css} mt-4 d-flex`}>
		<div className={`mr-4 ${image}`}></div>
		{message}
	</div>
)

// Rebecka, take a look at this!!
interface IErrorMessageLegacy {
	message: string
	css?: string
}
export const ErrorMessageLegacy = ({ css, message }: IErrorMessageLegacy) => (
	<div className={`error-message-legacy ${css} mt-4`}>{message}</div>
)

interface IErrorMessage {
	message: string
	css?: string
}

export const ErrorMessage = ({ css, message }: IErrorMessage) => (
	// <BoxInfo message={message} css={`fail ${css ?? ''}`} />
	<div className={`error-message ${css ?? ''}`}>{message}</div>
)

// aaand, take a look at this one too!!
interface IValidationError {
	message: string
	css?: string
}
export const ValidationError = ({ css, message }: IValidationError) => (
	<div className={`validation-error ${css}`}>{message}</div>
)

interface IBoxInfoSuccessCheckmark {
	css: string
	message: string | object
}

export const BoxInfoSuccessCheckmark = ({
	message,
	css,
}: IBoxInfoSuccessCheckmark) => (
	<div className={`box-info ${css}`}>
		<div className="success-img-box circle">
			<div className="checkmark draw"></div>
		</div>
		{message}
	</div>
)
